import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type MyInfoModuleSpecsFragment } from '../../../../api/fragments/MyInfoModuleSpecs';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import AddMyInfoSettingsForm from './AddMyInfoSettingsForm';

export type MyInfoSettingsDrawerProps = {
    onClose: () => void;
    visible: boolean;
    module: MyInfoModuleSpecsFragment;
};

const MyInfoSettingsDrawer = ({ onClose, visible, module }: MyInfoSettingsDrawerProps) => {
    const { t } = useTranslation(['myInfoModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('myInfoModuleDetails:myInfoSettingsDrawer.cancelButton')}</Button>
                    <Button form="addMyInfoSettings" htmlType="submit" type="primary">
                        {t('myInfoModuleDetails:myInfoSettingsDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('myInfoModuleDetails:myInfoSettingsDrawer.title.create')}
            visible={visible}
            destroyOnClose
        >
            <AddMyInfoSettingsForm module={module} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default MyInfoSettingsDrawer;

export const useMyInfoSettingsDrawer = (module: MyInfoModuleSpecsFragment) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <MyInfoSettingsDrawer module={module} onClose={actions.close} visible={visible} />,
    };
};
